// Chart N canvas
export const dataLabelsPlugin = {
  id: "dataLabels",
  afterDatasetsDraw(chart) {
    const { ctx } = chart;
    chart.data.datasets.forEach((dataset, i) => {
      const meta = chart.getDatasetMeta(i);
      meta.data.forEach((element, index) => {
        const value = dataset.data[index];
        if (value !== undefined && value !== null) {
          const x = element.x;
          const y = element.y;

          // Config tampilan kotak angka
          const text = value.toString();
          ctx.font = "bold 12px sans-serif";
          const textWidth = ctx.measureText(text).width;
          const padding = 6;
          const boxWidth = textWidth + padding * 2;
          const boxHeight = 24;
          const boxX = x - boxWidth / 2;
          const boxY = y - 35; // Posisi di atas titik

          // Gambar Kotak Putih dengan Border Biru
          ctx.save();
          ctx.beginPath();
          // Membuat rounded rectangle manual sederhana
          ctx.fillStyle = "#ffffff";
          ctx.strokeStyle = "#4BC0C0"; // Warna border (sama dengan garis)
          ctx.lineWidth = 2;

          // Menggambar background kotak
          ctx.roundRect
            ? ctx.roundRect(boxX, boxY, boxWidth, boxHeight, 5)
            : ctx.rect(boxX, boxY, boxWidth, boxHeight);
          ctx.fill();
          ctx.stroke();

          // Gambar Text Angka
          ctx.fillStyle = "#333333";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(text, x, boxY + boxHeight / 2);
          ctx.restore();
        }
      });
    });
  },
};

//  Collor Mapping for BGBadgeRole
export const mapppingColorForBGBadgeRole = {
  "super-user": "bg-dark",
  admin: "bg-danger",
  user: "bg-primary",
  operational: "bg-success",
  sales: "bg-warning",
  "cs-online": "bg-info",
  tls: "bg-secondary",
  mo: "bg-blue",
};

// Date
 export const formatDateIndo = (dateString, mode) => {
      const date = new Date(dateString);
      if (mode === "weekly")
        return `Week ${date.getDate()} ${date.toLocaleDateString("id-ID", {
          month: "short",
        })}`;
      return `${date.getDate()} ${date.toLocaleDateString("id-ID", {
        month: "short",
      })}`;
    };


